import searchIcon from "../../image/search.svg";
import successIcon from "../../image/success.svg";
import clearIcon from "../../image/clear.svg";
import PersonCode from "../PersonCode/PersonCode";
import React, { useState } from "react";
import { CheckFormProps } from "../../../../types/props";
import styles from "./CheckForm.module.scss";

export const CheckForm = ({
  id,
  eventData,
  foundTickets,
  setFoundTickets,
  type_form,
}: CheckFormProps) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [coincide, setCoincide] = useState<boolean | null>(null);
  const [invalid, setInvalid] = useState<boolean>(false);

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const value: string = event.target.value;
    setInvalid(false);
    setInputValue(value);

    if (value === "") {
      handleClear();
    }

    handleSearch(value);
  };

  // Поиск по введенному значению

  const handleSearch = (searchValue: string, type?: string) => {
    if (!eventData) return;

    const trimmed = searchValue.trim();
    if (trimmed === "") {
      setFoundTickets(eventData);
      setCoincide(null);
      setInvalid(false);
      return;
    }

    const normalInput = trimmed.toLowerCase();

    const exactMatches = eventData.filter(
      (ticket) =>
        ticket.ticket_number.toString().toLowerCase() === normalInput ||
        (type_form === "scanner" &&
          ticket.user_name.toLowerCase() === normalInput)
    );

    const prefixMatches = eventData.filter(
      (ticket) =>
        ticket.ticket_number.toString().toLowerCase().startsWith(normalInput) ||
        (type_form === "scanner" &&
          ticket.user_name.toLowerCase().includes(normalInput))
    );

    const newTicketNumbers =
      exactMatches.length > 0 ? exactMatches : prefixMatches;

    if (newTicketNumbers.length > 0) {
      setFoundTickets(newTicketNumbers);
      setInvalid(false);
    } else {
      setFoundTickets([]);
      setInvalid(true);
    }

    const isFound = exactMatches.length > 0;
    setCoincide(type === "click" ? isFound : isFound || null);
  };

  // Очистка поля ввода и сброс состояния

  const handleClear = () => {
    setInputValue("");
    setCoincide(null);
    setFoundTickets(eventData || []);
    setInvalid(false);
  };

  if (eventData.length === 0) {
    return (
      <div className={styles.checkFormEmpty}>
        <p className="check-form__empty__text">Купленные билеты не найдены</p>
      </div>
    );
  }

  return (
    <div className={styles.checkForm}>
      <div className={styles.searchWrapper}>
        <label htmlFor="search" className={styles.label}>
          Введите код билета
          {type_form === "scanner" ? " или имя участника" : ""}
        </label>
        <input
          id="search"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          className={`${styles.input} ${
            coincide
              ? styles.inputValid
              : coincide === false
              ? styles.inputInvalid
              : ""
          }`}
        />
        <button
          className={`${styles.searchWrapperIconBtn} ${
            coincide || inputValue === ""
              ? styles.searchWrapperIconBtnDisabled
              : ""
          }`}
          onClick={
            coincide === null
              ? () => handleSearch(inputValue, "click")
              : !coincide
              ? handleClear
              : undefined
          }
          disabled={coincide || inputValue === ""}
        >
          <img
            src={
              coincide === null
                ? searchIcon
                : coincide
                ? successIcon
                : clearIcon
            }
            alt="search"
          />
        </button>
        {coincide === false && (
          <span className={styles.searchWrapperError}>Неправильный код</span>
        )}
      </div>
      <div className={styles.resultsWrapper}>
        {foundTickets.map((ticketNumber) => (
          <PersonCode
            id={id}
            key={ticketNumber.ticket_number}
            ticket={ticketNumber}
            invalid={coincide === false || invalid}
            handleClear={handleClear}
          />
        ))}
      </div>
    </div>
  );
};
